/*
 *
 * Depends on: digistore-helpers.js, digistore-cart.js
 * Load order: after all other DS24 scripts.
 */

window.DS24 = window.DS24 || {};

DS24.cartUI = (() => {

    function fmt(amount) {
        return 'EUR ' + Number(amount).toFixed(2).replace('.', ',');
    }

    function buildItem(item, title) {

        const unitPrice  = Number(item.gross_amount || 0);
        const qty        = Number(item.quantity      || 1);
        const totalPrice = unitPrice * qty;
        const productId  = item.product_id;
        const isFree     = unitPrice === 0;

        if (isFree) {
            return `
                <div class="ds-cart-content">

                    <span class="ds-cart-name">${title}</span>

                    <div class="ds-cart-bottom">

                        <div class="ds-cart-mid">
                            <span class="ds-cart-free-badge">🎁 Gratis</span>
                        </div>

                        <div class="ds-cart-right">
                            <span class="ds-cart-total ds-cart-total--free">
                                EUR 0,00
                            </span>
                        </div>

                    </div>

                </div>
            `;
        }

        return `
            <div class="ds-cart-content">

                <span class="ds-cart-name">${title}</span>

                <div class="ds-cart-bottom">

                    <div class="ds-cart-mid">
                        <span class="ds-cart-unit">${fmt(unitPrice)} / Stück</span>

                        <div class="ds-qty"
                            data-product-id="${productId}"
                            data-unit-price="${unitPrice}">
                            <button class="ds-qty__btn ds-qty__minus" type="button">−</button>
                            <input class="ds-qty__input" type="number" value="${qty}" min="0">
                            <button class="ds-qty__btn ds-qty__plus" type="button">+</button>
                        </div>
                    </div>

                    <div class="ds-cart-right">
                        <span class="ds-cart-total">${fmt(totalPrice)}</span>
                        <span class="ds-cart-per">${qty} × ${fmt(unitPrice)}</span>

                        <button class="ds-cart-del"
                            data-product-id="${productId}"
                            aria-label="Artikel entfernen"
                            type="button">

                            <svg width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <polyline points="3 6 5 6 21 6"/>
                                <path d="M19 6l-1 14H6L5 6"/>
                                <path d="M10 11v6M14 11v6"/>
                                <path d="M9 6V4h6v2"/>
                            </svg>
                        </button>

                    </div>

                </div>

            </div>
        `;
    }

    function getItemData(productId) {
        const cart = window.ds24cart;
        if (!cart || !cart.items) return null;
        return cart.items.find(i => String(i.product_id) === String(productId)) || null;
    }

    function renderItem(node) {

        const productIdInput = node.querySelector('[app-product-id]');
        if (!productIdInput) return;

        const productId = productIdInput.getAttribute('app-product-id');

        if (node.dataset.dsUiRendered === productId) {
            return;
        }

        const title =
            node.querySelector('.app_cart_name')
                ?.textContent
                ?.trim() || '';

        const item = getItemData(productId);
        if (!item) return;

        node.querySelectorAll('.ds-cart-mid, .ds-cart-right').forEach(el => el.remove());

        const fragment = document.createElement('div');
        fragment.innerHTML = buildItem(item, title);

        while (fragment.firstChild) {
            node.appendChild(fragment.firstChild);
        }

        node.dataset.dsUiRendered = productId;
    }

    function renderAll() {
        document.querySelectorAll(
            '.app_cart_tooltip_container.open .app_cart_item'
        ).forEach(renderItem);
    }

    function refreshTotals(qtyWrapper) {

        const unitPrice = parseFloat(qtyWrapper.dataset.unitPrice);
        const input     = qtyWrapper.querySelector('.ds-qty__input');
        const qty       = Math.max(0, parseInt(input.value) || 0);
        const row       = qtyWrapper.closest('.app_cart_item');
        if (!row) return;

        const totalEl = row.querySelector('.ds-cart-total');
        const perEl   = row.querySelector('.ds-cart-per');
        if (totalEl) totalEl.textContent = fmt(unitPrice * qty);
        if (perEl)   perEl.textContent   = `${qty} × ${fmt(unitPrice)}`;
    }

    function bindEvents() {

        document.addEventListener('click', function (e) {

            if (e.target.closest('.ds-qty__minus')) {
                const wrapper = e.target.closest('.ds-qty__minus').closest('.ds-qty');
                const input   = wrapper.querySelector('.ds-qty__input');
                const next    = Math.max(0, (parseInt(input.value) || 0) - 1);
                input.value   = next;
                refreshTotals(wrapper);
                triggerDigistoreQtyUpdate(wrapper, next);
                return;
            }

            if (e.target.closest('.ds-qty__plus')) {
                const wrapper = e.target.closest('.ds-qty__plus').closest('.ds-qty');
                const input   = wrapper.querySelector('.ds-qty__input');
                const next    = (parseInt(input.value) || 0) + 1;
                input.value   = next;
                refreshTotals(wrapper);
                triggerDigistoreQtyUpdate(wrapper, next);
                return;
            }

            if (e.target.closest('.ds-cart-del')) {
                const productId = e.target.closest('.ds-cart-del').dataset.productId;
                triggerDigistoreDelete(productId);
                return;
            }
        });

        document.addEventListener('change', function (e) {
            if (!e.target.classList.contains('ds-qty__input')) return;
            const wrapper = e.target.closest('.ds-qty');
            const qty     = Math.max(0, parseInt(e.target.value) || 0);
            e.target.value = qty;
            refreshTotals(wrapper);
            triggerDigistoreQtyUpdate(wrapper, qty);
        });
    }

    function triggerDigistoreQtyUpdate(wrapper, qty) {

        const productId  = wrapper.dataset.productId;
        const row        = wrapper.closest('.app_cart_item');
        if (!row) return;

        const nativeInput = row.querySelector(
            `.app_cart_quantity[app-product-id="${productId}"]`
        );
        if (!nativeInput) return;

        nativeInput.value = qty;
        nativeInput.dispatchEvent(new Event('input',  { bubbles: true }));
        nativeInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (qty === 0) {
            const confirmMsg = nativeInput.getAttribute('app-confirm-msg');
            if (confirmMsg && !window.confirm(confirmMsg)) {
                const item = getItemData(productId);
                if (item) {
                    wrapper.querySelector('.ds-qty__input').value = item.quantity;
                    refreshTotals(wrapper);
                }
            }
        }
    }

    function triggerDigistoreDelete(productId) {
        const deleteBtn = document.querySelector(
            `.app_cart_delete[app-product-id="${productId}"]`
        );
        if (deleteBtn) deleteBtn.click();
    }

    function hookCartChange() {
        const original = window.onDigistoreCartChange;
        window.onDigistoreCartChange = function (cart) {
            if (typeof original === 'function') original(cart);
            setTimeout(renderAll, 150);
        };
    }

    function observeCartList() {
        new MutationObserver(renderAll).observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    function init() {
        hookCartChange();
        observeCartList();
        bindEvents();
    }

    document.addEventListener('DOMContentLoaded', init);

    return { renderAll };

})();